module.exports = __webpack_public_path__ + "img/play-store.12b30bb4.png";